module.exports = __webpack_public_path__ + "img/03g_Store_651.3f036ca5.jpg";